import React from 'react';
import styles from './CategoryButton.module.css';

function CategoryButton({ category, isActive, onClick }) {
  const { label, icon } = category;

  const renderIcon = () => {
    if (React.isValidElement(icon)) return icon;

    return (
      <img
        src={icon}
        alt={label}
        className={styles.categoryIcon}
      />
    );
  };

  return (
    <button
      type="button"
      className={`${styles.categoryItem} ${isActive ? styles.active : ''}`}
      onClick={onClick}
    >
      {renderIcon()}
      {label}
    </button>
  );
}

export default CategoryButton;